let MIN_MOVED = 20; //px

export default {
	data() {
		return {
			movableMoved: 0,
			movableMoving: false,
			movableMouseUp: null,
			movableMouseMove: null,
			movableMouseMoveMinMoved: null
		};
	},
	methods: {
		_startMoveColumn(e, targetColumn) {
			if (targetColumn.locked) return;

			e.preventDefault();
			e.stopPropagation();

			let startPoint = e.clientX;
			let [startElement] = this.$refs[`header-${targetColumn.field}`];
			let index = -1;

			for (let i = 0; i < this.localColumns.length; i++) {
				if (this.localColumns[i].field === targetColumn.field) {
					index = i;
					break;
				}
			}

			let originalIndex = index;
			let positions = this._calculateXPosOfColumns();

			this.movableMouseMove = (e) => {
				if (!this.movableMoving) return;
				let diff = e.clientX - this.lastScreenXPos;
				this.lastScreenXPos = e.clientX;
				for (let i = 0; i < positions.length; i++) {
					if (i === index) continue;
					if (i < index && diff >= 0) continue;
					if (i > index && diff <= 0) continue;

					let column = this.localColumns[i];
					let columnDef = this.localColumnDefinitions[column.field];
					if (columnDef.locked)
						continue;

					if (e.clientX < positions[i].maxX && e.clientX > positions[i].minX) {
						this.$set(this.localColumns, i, this.localColumns[index]);
						this.$set(this.localColumns, index, column);
						positions = this._calculateXPosOfColumns();
						index = i;
						break;
					}
				}
			};

			this.movableMouseMoveMinMoved = (e) => {
				this.movableMoved = Math.abs(e.clientX - startPoint);
				if (this.movableMoved > MIN_MOVED) {
					this.movableMoving = true;
					startElement.classList.add('grid-header-cell-moving');
					window.removeEventListener('mousemove', this.movableMouseMoveMinMoved);
					this.movableMouseMoveMinMoved = null;
				}
			};

			this.movableMouseUp = (e) => {
				this._endMoveColumn();
				startElement.classList.remove('grid-header-cell-moving');
				setTimeout(() => { this.movableMoving = false; }, 100);
				if (Math.abs(this.movableMoved) < MIN_MOVED) {
					return;
				}

				if (index !== originalIndex) {
					/**
					 * When column has moved. Payload is column name and new index.
					 * @event column-moved
					 * @type {object}
					 */
					this.$emit('column-moved', { name: targetColumn.field, newIndex: index });
					this._storeLocalColumns();
				}

				e.preventDefault();
				e.stopPropagation();
			};

			window.addEventListener('mousemove', this.movableMouseMove);
			window.addEventListener('mousemove', this.movableMouseMoveMinMoved);
			window.addEventListener('mouseup', this.movableMouseUp);
		},

		_calculateXPosOfColumns() {
			let baseOffset = this.$refs.headers.getBoundingClientRect().left;
			let result = [];
			let currOffset = baseOffset;
			for (let column of this.localColumns) {
				/*
				 * let elem = this.$refs[`header-${column.field}`][0];
				 * if(!elem)
				 * 	continue;
				 */

				// let rect = elem.getBoundingClientRect();
				let r = { name: column.field, minX: currOffset, maxX: currOffset + column.width };
				currOffset += column.width;
				result.push(r);
			}
			return result;
		},

		_endMoveColumn() {
			if (this.movableMouseMove) {
				window.removeEventListener('mousemove', this.movableMouseMove);
				this.movableMouseMove = null;
			}

			if (this.movableMouseMoveMinMoved) {
				window.removeEventListener('mousemove', this.movableMouseMoveMinMoved);
				this.movableMouseMoveMinMoved = null;
			}

			if (this.movableMouseUp) {
				window.removeEventListener('mouseup', this.movableMouseUp);
				this.movableMouseUp = null;
			}
		}
	}
};
